import React from 'react';
import { formatCurrency } from '../../utils/formatters';

export function FinancialReportRow({
  label,
  value,
  total = false,
  grand = false,
  muted = false
}) {
  const amount = Number(value || 0);
  const amountColor = grand
    ? amount < 0
      ? 'text-rose-600'
      : 'text-emerald-600'
    : amount < 0
      ? 'text-rose-600'
      : 'text-slate-900';

  return (
    <div
      className={`flex min-h-10 items-center justify-between border-b border-slate-100 py-2 ${
        total ? 'border-t border-slate-200 font-bold text-slate-900' : 'text-slate-700'
      } ${grand ? 'mt-2 py-3 text-base' : 'text-sm'}`}
    >
      <span className={muted ? 'text-slate-500' : ''}>{label}</span>
      <span
        className={`tabular-nums ${
          total || grand ? 'font-semibold' : 'font-medium'
        } ${amountColor}`}
      >
        {formatCurrency(amount)}
      </span>
    </div>
  );
}

export default function FinancialReportSection({
  title,
  rows,
  totalLabel,
  total,
  emptyLabel = 'No activity recorded for this period.'
}) {
  return (
    <section className="mb-6 overflow-hidden rounded-lg border border-slate-200 bg-white">
      <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
        <h2 className="text-sm font-medium text-slate-700">{title}</h2>
      </div>

      <div className="px-4">
        {rows || (
          emptyLabel && (
            <p className="py-4 text-sm italic text-slate-400">{emptyLabel}</p>
          )
        )}

        {totalLabel && (
          <FinancialReportRow label={totalLabel} value={total} total />
        )}
      </div>
    </section>
  );
}